import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";

/* eslint-disable react/jsx-no-bind */
import React from 'react';
import types from 'prop-types';
import { styled } from '@rexlabs/styling';
import styles from '../styles/day-picker-keyboard-shortcuts';
import { DayPickerKeyboardShortcutsPhrases } from '../defaultPhrases';
import getPhraseTypes from '../utils/getPhrasePropTypes';
var assign = _Object$assign;
export var TOP_LEFT = 'topLeft';
export var TOP_RIGHT = 'topRight';
export var BOTTOM_RIGHT = 'bottomRight';
var propTypes = {
  block: types.bool,
  buttonLocation: types.oneOf([TOP_LEFT, TOP_RIGHT, BOTTOM_RIGHT]),
  showKeyboardShortcutsPanel: types.bool,
  openKeyboardShortcutsPanel: types.func,
  closeKeyboardShortcutsPanel: types.func,
  labels: types.shape(getPhraseTypes(DayPickerKeyboardShortcutsPhrases))
};
var defaultProps = {
  block: false,
  buttonLocation: BOTTOM_RIGHT,
  showKeyboardShortcutsPanel: false,
  openKeyboardShortcutsPanel: function openKeyboardShortcutsPanel() {},
  closeKeyboardShortcutsPanel: function closeKeyboardShortcutsPanel() {},
  labels: DayPickerKeyboardShortcutsPhrases
};
var ShortcutRow = assign(function (_ref) {
  var unicode = _ref.unicode,
      label = _ref.label,
      action = _ref.action,
      block = _ref.block,
      styles = _ref.styles;
  return /*#__PURE__*/React.createElement("li", styles(_defineProperty({
    row: true
  }, "row_".concat(block), true)), /*#__PURE__*/React.createElement("div", styles(_defineProperty({
    keys: true
  }, "keys_".concat(block), true)), /*#__PURE__*/React.createElement("span", _extends({}, styles('key'), {
    role: "img",
    "aria-label": label
  }), unicode)), /*#__PURE__*/React.createElement("div", styles('action'), action));
}, {
  displayName: 'KeyboardShortcutRow'
});
export var KeyboardShortcutRow = styled(styles)(ShortcutRow);
KeyboardShortcutRow.propTypes = {
  unicode: types.string.isRequired,
  label: types.string.isRequired,
  action: types.string.isRequired
};
var showKeyboardShortcutsButton;

var DayPickerKeyboardShortcuts = function DayPickerKeyboardShortcuts(_ref2) {
  var block = _ref2.block,
      buttonLocation = _ref2.buttonLocation,
      showKeyboardShortcutsPanel = _ref2.showKeyboardShortcutsPanel,
      openKeyboardShortcutsPanel = _ref2.openKeyboardShortcutsPanel,
      closeKeyboardShortcutsPanel = _ref2.closeKeyboardShortcutsPanel,
      closeButton = _ref2.closeButton,
      labels = _ref2.labels,
      styles = _ref2.styles;
  var keyboardShortcuts = [{
    unicode: '↵',
    label: labels.enterKey,
    action: labels.selectFocusedDate
  }, {
    unicode: '←/→',
    label: labels.leftArrowRightArrow,
    action: labels.moveFocusByOneDay
  }, {
    unicode: '↑/↓',
    label: labels.upArrowDownArrow,
    action: labels.moveFocusByOneWeek
  }, {
    unicode: 'PgUp/PgDn',
    label: labels.pageUpPageDown,
    action: labels.moveFocusByOneMonth
  }, {
    unicode: 'Home/End',
    label: labels.homeEnd,
    action: labels.moveFocustoStartAndEndOfWeek
  }, {
    unicode: 'Esc',
    label: labels.escape,
    action: labels.returnFocusToInput
  }, {
    unicode: '?',
    label: labels.questionMark,
    action: labels.openThisPanel
  }];
  var toggleButtonText = showKeyboardShortcutsPanel ? labels.hideKeyboardShortcutsPanel : labels.showKeyboardShortcutsPanel;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", _extends({
    ref: function ref(_ref3) {
      showKeyboardShortcutsButton = _ref3;
    }
  }, styles(_defineProperty({
    showButton: true
  }, buttonLocation, true)), {
    type: "button",
    "aria-label": toggleButtonText,
    onClick: function onClick(e) {
      showKeyboardShortcutsPanel ? closeKeyboardShortcutsPanel(e) : openKeyboardShortcutsPanel(function () {
        showKeyboardShortcutsButton.focus();
      });
    },
    onMouseUp: function onMouseUp(e) {
      e.currentTarget.blur();
    }
  }), /*#__PURE__*/React.createElement("span", styles(_defineProperty({
    showButtonLabel: true
  }, "showButtonLabel_".concat(buttonLocation), true)), "?")), showKeyboardShortcutsPanel && /*#__PURE__*/React.createElement("div", _extends({}, styles('panel'), {
    role: "dialog",
    ariaLabelledby: "DayPickerKeyboardShortcuts__title"
  }), /*#__PURE__*/React.createElement("div", _extends({
    id: "DayPickerKeyboardShortcuts__title"
  }, styles('title')), labels.keyboardShortcuts), /*#__PURE__*/React.createElement("button", _extends({}, styles('closeButton'), {
    type: "button",
    "aria-label": labels.hideKeyboardShortcutsPanel,
    onClick: closeKeyboardShortcutsPanel,
    onKeyDown: function onKeyDown(e) {
      // Because the close button is the only focusable element inside of the panel, this
      // amount to a very basic focus trap. The user can exit the panel by "pressing" the
      // close button or hitting escape
      if (e.key === 'Tab') {
        e.preventDefault();
      }
    }
  }), closeButton), /*#__PURE__*/React.createElement("ul", styles('list'), _mapInstanceProperty(keyboardShortcuts).call(keyboardShortcuts, function (_ref4) {
    var unicode = _ref4.unicode,
        label = _ref4.label,
        action = _ref4.action;
    return /*#__PURE__*/React.createElement(KeyboardShortcutRow, {
      key: label,
      unicode: unicode,
      label: label,
      action: action,
      block: block
    });
  }))));
};

DayPickerKeyboardShortcuts.propTypes = propTypes;
DayPickerKeyboardShortcuts.defaultProps = defaultProps;
export default styled(styles)(DayPickerKeyboardShortcuts);